import { FiMessageSquare, FiMail } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const ContactChannels = () => {
  const navigate = useNavigate();
  return (
    <>
      <h3 className="contact-section-title">Contact Channels</h3>

      <div className="contact-grid">
        {/* Live Chat */}
        <div className="contact-card">
          <div className="contact-icon chat">
            <FiMessageSquare />
          </div>

          <div className="contact-info">
            <h4>Live Chat</h4>
            <span className="status online">● Online Now</span>
            <p>Avg response: 2 minutes</p>
          </div>
        </div>

        {/* Email */}
        <div  onClick={()=>navigate('/supports/email')} className="contact-card">
          <div className="contact-icon email">
            <FiMail />
          </div>

          <div className="contact-info">
            <h4>Email Support</h4>
            <p>Response within 2 hours</p>
            <p className="email">support@partner.com</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactChannels;
